module.exports = [{
    title: "人员身份管理软件",
    id: 'a0',
    desc: '以人为核心，全周期、多维度人员身份智能管理，动作、姿态、视线等信息，集成强大的智能化算法和智能化设备，形成统一化人员管理软件系统。',
    img: [
        '1.png',
        '2.png',
    ],
    introduce: [

        {
            type: "html",
            class: 'd-a1',
            inner: `
                <p class="tit">系统简介</p>
                <p >● 以人为核心，多要素智能检测</p>
                <p >●  以场景为坐标，多点位接入</p>
                <p >●  人员身份+行为+定位，综合管控</p>
                <p >●  人员身份合规、人员轨迹合规、人员操作合规</p>
                <p >●  多种方式处置，科学有效</p>
                
            `
        },
        {
            type: "html",
            class: 'd-a2',
            inner: `
                <p class="tit">特点及优势</p>
                <p >●  高安全生物特征，杜绝冒名</p>
                <p >●  便捷高效，杜绝繁琐</p>
                <p > ●  划分区域权限，杜绝串岗</p>
                <p > ●  轨迹可追溯，杜绝托管</p>
            `
        },


    ],
},
{
    title: "洁净服全生命周期管理软件",
    id: 'a1',
    img: [
        '3.png',
        '4.png',
    ],
    desc: '洁净服管理系统是用于管理和跟踪洁净服的使用、清洗、维护和更换等活动的系统。洁净服是一种专门设计的服装，用于在洁净环境中（如医疗、实验室、电子生产等场所）工作时保持工作环境的洁净度和无菌性。洁净服管理系统的主要功能包括：',
    introduce: [

        {
            type: "html",
            class: 'd-b1',
            inner: `
            <p class="tit">系统简介</p>
        <p > ● 洁净服领用记录：系统可以记录每位员工领用洁净服的信息，包括领用时间、数量、员工姓名等，实现洁净服的个人化管理</p>
        <p > ● 洁净服清洗与维护：系统可以跟踪洁净服的清洗和维护情况，包括清洗时间、清洗方式、维护记录等，确保洁净服的清洁和无菌性</p>
        <p >●  洁净服效期管理：系统可以设定洁净服更换周期并提醒员工及时更换洁净服，避免过期使用或污染风险</p>
        <p >●  洁净服库存管理：系统可以实时监控洁净服库存量，提醒及时补充，确保员工有足够的洁净服可使用</p>
        <p > ● 审批流程：系统能够实现洁净服领用和清洗等活动的审批流程管理，提高管理效率和规范性</p>
        <p >● 数据报表分析：系统可以生成洁净服使用情况、清洗记录等报表，为管理者提供数据分析和决策依据</p>

       
        `,
        },
        {
            type: "html",
            class: 'd-b2',
            inner: `
        
        <p class="tit">特点及优势</p>
        <p > ● 提高工作效率：洁净服管理系统可以减少人工管理成本，提高工作效率，减少因管理不善而导致的错误和问题</p>
        <p > ● 强化洁净环境控制：通过洁净服管理系统的规范管理，可以加强洁净环境的控制，提高工作环境的洁净度和无菌性</p>
        <p > ● 提升安全性：洁净服管理系统可以提醒员工及时更换洁净服，降低受污染的风险，提升工作场所的安全性</p>
        <p > ● 数据统计与分析：系统能够生成洁净服使用数据报表，帮助管理者对洁净服使用情况进行分析，发现问题并及时修正</p>
        <p > ● 规范管理流程：洁净服管理系统能够规范洁净服的使用和清洗流程，确保管理流程的规范性和科学性</p>
        `,
        }
    ],
},
{
    title: "人员行为管理软件",
    id: 'a2',
    img: [
        '5.png',
        '6.png',
    ],
    desc: '以智能行为分析算法为核心，对人员的行为、动作进行分析理解，利用AIGC、计算机视觉、自然语言处理等人工智能最新技术，最大程度的解决相关行业管理难的问题。',
    introduce: [

        {
            type: "html",
            class: 'd-c1',
            inner: `
        <p class="tit">系统简介</p>
        <p >● 系统通过AI视觉技术和高性能智能算法，实现主动违规动作检测、动作姿态检测，极大提高企业的应急处置及管理能力</p>
       
        `
        },
        {
            type: "html",
            class: 'd-c2',
            inner: `
       
        <p class="tit">特点及优势</p>
        <p >● 违规行为及时告警，保证人身及环境安全</p>
        <p >● 报警画面直观展示，提高人员管理效率</p>
        `
        }
    ],
},
{
    title: "电子实验记录本（ELN)",
    id: 'a3',
    img: [
        '7.png',
        '8.png',
    ],
    desc: '针对实验室管理混乱、实验数据流失率高、安全管理难度大、分享传承困难等业务痛点，以设备智能化管理、项目智能管理、实验数据管理、实验物料管理为基础，形成真实、完整、可追溯的电子实验记录本系统。',
    introduce: [

        {
            type: "html",
            class: 'd-d1',
            inner: `
        <p class="tit">系统简介</p>
        <p > ● ELN系统的主要功能是替代传统的纸质实验记录本，将实验数据、实验过程和实验结果等信息以电子形式进行记录和管理 </p>
       

        `
        },
        {
            type: "html",
            class: 'd-d2',
            inner: `
       
        <p class="tit">特点及优势</p>
        <p >● 电子化记录：ELN系统将实验数据、实验过程、实验结果等信息以电子形式进行记录，避免了传统纸质记录本的繁琐和易丢失的问题</p>
        <p >● 可追踪性：ELN系统能够追踪整个实验流程，包括实验计划、实验执行、数据记录等步骤，确保实验数据的准确性和可信度</p>
        <p >● 数据共享与协作：ELN系统支持多人共享实验数据，团队成员可以方便地查看、编辑和共享数据，促进团队合作和交流</p>
        <p >● 数据分析与报告：ELN系统具有数据分析功能，可以对实验数据进行统计、分析和可视化，生成报告和图表，帮助科研人员更好地理解数据和结果</p>
        <p >● 数据安全性：ELN系统提供数据加密、权限控制和备份功能，保障实验数据的安全性，防止数据泄霁和丢失</p>
        <p >● 提升效率：ELN系统能够简化实验记录流程，减少手工操作，提高工作效率，让科研人员能够专注于实验设计和数据分析</p>

        `
        },
    ],
},
{
    title: "人工智能算法平台",
    id: 'a4',
    img: [
        '9.png',
        '10.png',
        '11.png',
    ],
    desc: '人工智能研发平台是复杂的AI体系和复杂的业务体系之间的一座桥梁，能够将业务需求通过机器学习、自然语言处理、视觉技术、智能决策技术等人工智能手段融合到业务管理中，同时能够有效保护数据安全、节省人力成本',
    introduce: [

        {
            type: "html",
            class: 'd-e1',
            inner: `
        <p class="tit">平台介绍</p>
        <p >● 以自然语言的方式，通过语音文本与智能系统进行交互，实现从信息系统到智能助理的巨大跨越 </p>
     

        `
        },
        {
            type: "html",
            class: 'd-e2',
            inner: `
        <p class="tit">平台优势</p>
        <p >● 系统能够通过与实验室相关设备的对接，实时获取科研人员的操作记录并上传系统</p>

        `
        },
        {
            type: "html",
            class: 'd-e3',
            inner: `

    

        <p class="tit">行业推广</p>
        <p >● 全过程电子记录，减少人力操作</p>
        <p >● 数据真实、安全、可靠</p>

        `
        }
    ],
},
{
    title: "开源信息搜集处理系统",
    id: 'a5',
    img: [
        'osint-arch.jpg',
        'osint-ui.jpg',
    ],
    desc: '开源信息搜集处理系统V1.0是面向开源信息采集、翻译、汇聚、分析、研判与报告输出的综合性软件平台。系统以多模态数据采集为入口，以多语言智能翻译为桥梁，以数据汇聚分析与检索为核心，以智能体和智能报告为输出手段，形成从信息发现到研判成文的完整闭环。系统由多模态数据采集、多语言智能翻译、数据汇聚分析与检索、数据导出与接口、大模型与智能体管理、内网私有化部署、系统管理七个子系统组成，支持公网采集与内网分析相结合的部署方式，适用于开源信息监测、区域国别研究、行业情报跟踪和专题研判等业务场景。',
    introduce: [

        {
            type: "html",
            class: 'd-f1',
            inner: `
        <p class="tit">系统总体架构</p>
        <p >● 采集层：多模态数据采集，覆盖网页、社交、视频等多源信源</p>
        <p >● 翻译层：多语言智能翻译，东南亚重点语种专用模型支撑</p>
        <p >● 分析层：数据汇聚、检索、统计、事件与实体分析</p>
        <p >● 输出层：大模型与智能体驱动，智能报告自动生成</p>
        <p >● 部署层：公网采集与内网私有化分析相结合</p>

        `
        },
        {
            type: "html",
            class: 'd-f2',
            inner: `
        <p class="tit">特点及优势</p>
        <p >● 信源覆盖广：新闻、社交、视频、论坛、公告等多形态信源</p>
        <p >● 小语种能力强：东南亚重点语种专用翻译模型与术语库</p>
        <p >● 分析链条完整：检索、统计、事件、实体、报告数据贯通</p>
        <p >● 部署灵活安全：公网采集与内网分析结合，支持私有化部署</p>
        `
        },
        {
            type: "html",
            class: 'd-f3',
            inner: `
        <p class="tit">产品资料</p>
        <div class="doc-card">
            <div class="doc-card-icon">
                <svg viewBox="0 0 48 48" width="44" height="44" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 4h20l10 10v28a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" fill="#fff" stroke="#d64541" stroke-width="2"/>
                    <path d="M30 4l10 10H30z" fill="#f2c4c2" stroke="#d64541" stroke-width="2" stroke-linejoin="round"/>
                    <rect x="6" y="26" width="36" height="12" rx="2" fill="#d64541"/>
                    <text x="24" y="35.5" text-anchor="middle" font-size="8" font-weight="700" fill="#fff" font-family="Arial, sans-serif">PDF</text>
                </svg>
            </div>
            <div class="doc-card-info">
                <p class="doc-card-name">开源信息搜集处理系统_产品说明书_V1.0</p>
                <p class="doc-card-meta">PDF 文档 · 中文 · 约 8.7 MB</p>
            </div>
            <a class="doc-card-btn" href="/static/download/开源信息搜集处理系统_产品说明书_V1.0.pdf" download="开源信息搜集处理系统_产品说明书_V1.0.pdf">
                <i class="el-icon-download"></i><span>下载说明书</span>
            </a>
        </div>
        `
        },
    ],
},

];